/**
 * Users Cache Service
 * Caches users documents from Firestore to avoid repeated DB calls
 */

import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase.config';
import { getTenantStoreContext } from './userStoreCache';
import { DEFAULT_UNAUTH_TENANT_PATH } from '../localTenantConfig';
import { useUsersStore } from '../stores';

// localStorage caching removed - using Firestore persistent cache only

/**
 * Initialize users cache - sets up real-time listener for users
 * @param {boolean} useDefaultPath - If true, use default tenant/store path (for pre-auth loading)
 * @returns {Function} Unsubscribe function
 */
export const initializeUsersCache = (useDefaultPath = false) => {
  let tenantId, storeId;
  
  if (useDefaultPath) {
    // Use default path for pre-auth loading
    const defaultPath = DEFAULT_UNAUTH_TENANT_PATH || 'tenants/1234/stores/999';
    const parts = defaultPath.split('/');
    tenantId = parts[1];
    storeId = parts[3];
  } else {
    const context = getTenantStoreContext();
    tenantId = context.tenantId;
    storeId = context.storeId;
  }
  
  if (!tenantId || !storeId) {
    console.warn('⚠️ Cannot initialize users cache: No tenant/store context');
    return () => {};
  }

  // Firestore persistent cache handles offline data automatically

  console.log(`👥 Initializing users cache with real-time listener for tenant ${tenantId}, store ${storeId}`);

  const usersPath = `tenants/${tenantId}/stores/${storeId}/users`;
  const usersRef = collection(db, usersPath);

  const unsubscribe = onSnapshot(
    usersRef,
    (snapshot) => {
      const users = {};
      snapshot.forEach((doc) => {
        users[doc.id] = { id: doc.id, ...doc.data() };
      });

      console.log(`✅ Users updated in Zustand store: ${Object.keys(users).length} user(s)`);

      // Store entire users object in Zustand
      const setUsers = useUsersStore.getState().setUsers;
      setUsers(users);
    },
    (error) => {
      console.error('❌ Error in users subscription:', error);
    }
  );

  return unsubscribe;
};

